import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function NotFound() {
  return (
    <motion.section
      className="page-inner flex min-h-[50vh] items-center justify-center"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4 }}
    >
      <div className="text-center space-y-7">
        <h1 className="font-sans text-7xl font-light tracking-[-0.04em] text-[var(--text-tertiary)] sm:text-8xl">
          404
        </h1>
        <p className="font-mono text-[11px] uppercase tracking-[0.14em] text-[var(--text-secondary)]">
          Page not found
        </p>
        <Link
          to="/"
          className="group inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.14em] text-[var(--text-tertiary)] transition-colors hover:text-[var(--text)]"
        >
          Back to Home
          <span className="inline-block transition-transform group-hover:translate-x-1">&rarr;</span>
        </Link>
      </div>
    </motion.section>
  );
}
